import axios from "axios";

/**
 * Get all Clients in System
 * @returns {Promise<AxiosResponse | void>}
 */
export const getClients = () => {
    return axios.get(process.env.REACT_APP_API_ADDRESS+'/api/clients').then(res => res.data)
        .catch(error => console.log(error));
};

/**
 * Get all clients based on exam type
 * @param {string} type 
 * @returns 
 */
export const getClientsByType = (type) => {
  return axios
    .get(process.env.REACT_APP_API_ADDRESS + "/api/clientsByType", {
      params: {
        type,
      },
    })
    .then((res) => res.data)
    .catch((error) => console.log(error));
};

/**
 * Get detailed info Clients in System
 * @returns {Promise<AxiosResponse | void>}
 */
export const getDetailedClients = () => {
    return axios.get(process.env.REACT_APP_API_ADDRESS+'/api/admin/clients').then(res => res.data)
        .catch(error => console.log(error));
};


/**
 * update client Status
 * @returns {Promise<AxiosResponse | void>}
 */
export const updateStatus = (client) => {
    return axios.post(process.env.REACT_APP_API_ADDRESS+'/api/client/statusUpdate', {
        id: client.id,
        online:client.online
    },{
        headers: {
            'Accept':'application/json',
            'Content-Type': 'application/json'
        }
    });
};

/**
 * update client Status
 * @returns {Promise<AxiosResponse | void>}
 */
export const updateExisting = (client) => {
    return axios.post(process.env.REACT_APP_API_ADDRESS+'/api/client/updateClient', {
        id: client.id,
        name: client.organization_name,
        contact: client.client_contact,
        email: client.client_email,
        online:client.online,
        province_ids: client.province_ids,
        allow_rescheduling: client.allow_rescheduling 
    }, {
        headers: {
            'Accept':'application/json',
            'Content-Type': 'application/json'
        }
    });
};

/**
 * update client Status
 * @returns {Promise<AxiosResponse | void>}
 */
export const saveNewClient = (client) => {
    return axios.post(process.env.REACT_APP_API_ADDRESS+'/api/clients', {
        name: client.organization_name,
        contact: client.client_contact,
        email: client.client_email,
        online: client.online,
        province_ids: client.province_ids,
        allow_rescheduling: client.allow_rescheduling 
    }, {
        headers: {
            'Accept':'application/json',
            'Content-Type': 'application/json'
        }
    });
};

/**
 * Get all Provinces
 * @returns {Promise<AxiosResponse | void>}
 */
export const getProvinces = () => {
    return axios
        .get(process.env.REACT_APP_API_ADDRESS + "/api/provinces")
        .then((res) => res.data)
        .catch((error) => console.log(error));
};